import React from 'react';
import { map, filter } from 'lodash';
import cn from 'classnames';
import { useIntl } from 'react-intl';
import core from '@gin-betting/core';

import globalMsgs from 'messages';
import { usePureSelector } from 'hooks';
import { GameLogo } from 'components';
import { ALL } from '../../../constants';
import './sportTabs.scss';

const {
    entities: {
        selectors: { selectSports },
    },
} = core;

interface Props {
    sports: string[];
    activeSport: string;
    isNarrow: boolean;
    makeHandleChangeSport: (
        sportId: string
    ) => (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const SportTabs: React.FC<Props> = ({
    sports,
    activeSport,
    makeHandleChangeSport,
    isNarrow,
}) => {
    const { formatMessage } = useIntl();

    const allSports = usePureSelector(selectSports);
    const sportsIds = filter(sports, sport => sport !== ALL);

    return (
        <div styleName={cn('container', { 'is-narrow': isNarrow })}>
            <div
                styleName={cn('sport all-button ', {
                    active: activeSport === ALL,
                })}
                onClick={makeHandleChangeSport(ALL)}
            >
                <span>{formatMessage(globalMsgs.all)}</span>
            </div>

            {map(sportsIds, sportId => {
                const isActive = activeSport === sportId;
                const sportName = allSports.get(sportId)?.name ?? '';

                return (
                    <div
                        styleName={cn('sport', {
                            active: isActive,
                        })}
                        onClick={makeHandleChangeSport(sportId)}
                        key={sportId}
                    >
                        <div styleName="logo" title={sportName}>
                            <GameLogo gameId={sportId} />

                            {isActive && (
                                <span styleName="name">{sportName}</span>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default React.memo(SportTabs);
